import { IProductItemDto } from '../../../refund-calculator-types';

import CalculatorProductItem from '../calculator-product-item/calculator-product-item';

interface ICalculatorCategoryProps {
    data: IProductItemDto[];
    title: React.ReactNode;
}

const CalculatorItemsCategory: React.FC<ICalculatorCategoryProps> = ({ data, title = "" }) => {
    return (
        <div className="refund-calculator__category">
            {title}
            <div className="refund-calculator__category-items">
                {data.map((item, index) => (
                    <div key={index} className="refund-calculator__category-item">
                        <CalculatorProductItem {...item} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CalculatorItemsCategory;
